import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, NumberInput, Stack, Text } from "@mantine/core";
import { getSettingsState, setSetting } from "../../reducers/settingReducer.js";
import { useAppAction, useAppSelector } from "../../hooks/redux.js";
import { useCallback } from "react";
import { Event } from "../../constants/events.js";
import { IconFocus2 } from "@tabler/icons-react";
import { useCaptureEvent, useMap } from "../../components/StyleEditorContext.js";
import { FormattedMessage, useIntl } from "react-intl";
import { round } from "es-toolkit/compat";
export const MapOriginConfig = () => {
    const captureEvent = useCaptureEvent();
    const map = useMap();
    const intl = useIntl();
    const settings = useAppSelector(getSettingsState);
    const setSettingsAction = useAppAction(setSetting);
    const { zoom = 0, center = [0, 0], pitch = 0, bearing = 0, } = settings;
    const handleChange = useCallback((change) => {
        captureEvent(Event.ChangeMapOrigin, change);
        setSettingsAction(change);
    }, [captureEvent, setSettingsAction]);
    const handleSetCurrent = useCallback(() => {
        if (!map)
            return;
        captureEvent(Event.CaptureMapOrigin);
        setSettingsAction({
            center: map
                .getCenter()
                .toArray()
                .map(v => round(v, 6)),
            zoom: round(map.getZoom(), 3),
            pitch: round(map.getPitch(), 2),
            bearing: round(map.getBearing(), 2),
        });
    }, [captureEvent, setSettingsAction, map]);
    return (_jsxs(Stack, { w: "100%", gap: "xs", children: [_jsx(Text, { fz: "sm", fw: "bold", children: _jsx(FormattedMessage, { id: "label.mapOrigin", defaultMessage: "Map origin" }) }), _jsx(NumberInput, { size: "xs", label: intl.formatMessage({
                    defaultMessage: "Zoom level",
                    id: "label.zoomLevel",
                }), value: zoom, min: 0, max: 22, onChange: (value) => {
                    handleChange({ zoom: Number(value) });
                } }), _jsx(NumberInput, { size: "xs", label: intl.formatMessage({
                    defaultMessage: "Longitude",
                    id: "label.longitude",
                }), value: center[0], onChange: (value) => {
                    handleChange({ center: [Number(value), center[1]] });
                } }), _jsx(NumberInput, { size: "xs", label: intl.formatMessage({
                    defaultMessage: "Latitude",
                    id: "label.latitude",
                }), value: center[1], onChange: (value) => {
                    handleChange({ center: [center[0], Number(value)] });
                } }), _jsx(NumberInput, { size: "xs", label: intl.formatMessage({
                    defaultMessage: "Tilt",
                    id: "label.tilt",
                }), value: pitch, onChange: (value) => {
                    handleChange({ pitch: Number(value) });
                } }), _jsx(NumberInput, { size: "xs", label: intl.formatMessage({
                    defaultMessage: "Rotation",
                    id: "label.rotation",
                }), value: bearing, onChange: (value) => {
                    handleChange({ bearing: Number(value) });
                } }), _jsx(Button, { variant: "default", size: "xs", leftSection: _jsx(IconFocus2, { size: 16 }), onClick: handleSetCurrent, children: _jsx(FormattedMessage, { id: "button.setCurrentView", defaultMessage: "Set current view" }) })] }));
};
